import { render, staticRenderFns } from "./DiscountReport.vue?vue&type=template&id=1aa0b8c4&"
import script from "./DiscountReport.vue?vue&type=script&lang=js&"
export * from "./DiscountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports